import { Stack, chipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "DrawerHeader";

export const classes = {
  root: `${PREFIX}-root`,
  topContainer: `${PREFIX}-topContainer`,
  titleContainer: `${PREFIX}-titleContainer`,
  title: `${PREFIX}-title`,
  chip: `${PREFIX}-chip`,
};

export const DrawerHeader = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    alignItems: "start",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    [`& .${classes.topContainer}`]: {
      alignSelf: "stretch",
      flexDirection: "row",
      alignItems: "start",
      justifyContent: "space-between",
      [`& .${classes.titleContainer}`]: {
        alignItems: "start",
        flex: "auto",
        flexDirection: "column",
        gap: theme.spacing(1),
        [`& .${classes.title}`]: {
          marginTop: "5px",
        },
      },
    },
    [`& .${classes.chip}`]: {
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      [`& .${chipClasses.label}`]: {
        padding: 0,
      },
    },
  },
}));
